import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Bookmark, X } from "lucide-react";

/** Per-admin named filter sets. props: page (string), params (object), onApply(params) */
export const SavedViews = ({ page, params, onApply }) => {
  const [views, setViews] = useState([]);
  const load = () => api.get(`/admin/saved-views?page=${page}`).then(({ data }) => setViews(data.views)).catch(() => {});
  useEffect(() => { load(); }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    const name = window.prompt("Name this view (e.g. 'Quarantined HC pitches'):");
    if (!name || !name.trim()) return;
    try {
      await api.post("/admin/saved-views", { page, name: name.trim(), params });
      toast.success(`View "${name.trim()}" saved`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  const remove = async (v, e) => {
    e.stopPropagation();
    await api.delete(`/admin/saved-views/${v.id}`).catch(() => {});
    setViews(views.filter((x) => x.id !== v.id));
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`saved-views-${page}`}>
      <button data-testid="save-view-btn" onClick={save} title="Save current filters as a view"
        className="inline-flex items-center gap-1 px-2.5 py-1.5 text-[10px] tracking-widest border border-neutral-700 text-neutral-400 hover:border-volt hover:text-volt transition-colors">
        <Bookmark size={11} /> SAVE VIEW
      </button>
      {views.map((v) => (
        <button key={v.id} data-testid={`saved-view-${v.id}`} onClick={() => onApply(v.params)}
          className="group inline-flex items-center gap-1.5 px-2.5 py-1.5 text-[10px] tracking-widest border border-neutral-800 text-neutral-300 hover:border-blaze transition-colors">
          {v.name.toUpperCase()}
          <X size={10} data-testid={`saved-view-delete-${v.id}`} className="text-neutral-600 group-hover:text-blaze" onClick={(e) => remove(v, e)} />
        </button>
      ))}
    </div>
  );
};
